import { Fail } from './fail';

export class BlobParseFail extends Fail {
  _message = 'Failed to parse file from server';
}
